import {Expose, Type} from "class-transformer";
import {RequisitePsystemTargetType} from "@enums/RequisitePsystemTargetType";
import PaymentSystemCountry from "@models/operations/components/PaymentSystemCountry";

export default class RequisitePsystem {
    @Expose({name: "id"})
    private readonly _id: number | null;
    @Expose({name: "targetType"})
    private readonly _targetType: RequisitePsystemTargetType;
    @Expose({name: "name"})
    private readonly _name: string;
    @Expose({name: "sysName"})
    private readonly _sysName: string;
    @Expose({name: "imgPath"})
    private readonly _imgPath: string;
    @Expose({name: "addressTypes"})
    private readonly _addressTypes: number[] = [];
    @Expose({name: 'country'})
    @Type(() => PaymentSystemCountry)
    private _country: PaymentSystemCountry;

    constructor(
        id: number | null = null,
        name: string = '',
        targetType: RequisitePsystemTargetType = RequisitePsystemTargetType.P2P,
        sysName: string = '',
        imgPath: string = '',
        addressTypes: number[] = [],
        country: PaymentSystemCountry = new PaymentSystemCountry()
    ) {
        this._id = id;
        this._name = name;
        this._targetType = targetType;
        this._sysName = sysName;
        this._imgPath = imgPath;
        this._addressTypes = addressTypes;
        this._country = country;
    }

    get imgPath(): string {
        return this._imgPath;
    }

    get sysName(): string {
        return this._sysName;
    }

    get addressTypes(): number[] {
        return this._addressTypes;
    }

    get name(): string {
        return this._name;
    }

    get targetType(): RequisitePsystemTargetType {
        return this._targetType;
    }

    get id(): number | null {
        return this._id;
    }

    get country(): PaymentSystemCountry | null {
        return this._country;
    }
}
